import { AutogenLayoutFactoringImages } from "./autogen/AutogenLayoutFactoringImages";

export class FactoringImages extends AutogenLayoutFactoringImages {
}
